import { gsap } from "gsap"
import { awdScroll, isAllMobileDevices, winsize, SVGRoundedButtons } from "./bundle"

class AjaxFilters{
    constructor(container){
        this.container = container //nextContainer
        this.pageShopTitle = container.querySelector('.js-title')
        this.productsWrapper = this.container.querySelector('.products')
        this.products = [...this.productsWrapper.querySelectorAll('.product')]
        this.categorieAjax = [...this.container.querySelectorAll('.categoria--ajax')]
        this.isScrolling = false

        this.initEvents()
    }

    initEvents(){
        this.categorieAjax.forEach( categoriaAjax => {
            categoriaAjax.addEventListener('click', e => {
                e.preventDefault()
                e.stopPropagation()
                if(categoriaAjax.classList.contains('current')) return
                awdScroll.stop()
                const categoryId = categoriaAjax.getAttribute('data-category-id')
                this.categoryName = categoriaAjax.getAttribute('data-category-name')
                this.setCurrentCategory(categoriaAjax)
                this.hideTitle()
                this.hidePorducts().then(() => {
                    this.scrollToTop()
                    // this.updateTitle()
                    this.ajaxFilter(categoryId).then( () => {
                        this.reinitSVGRoundedButtons()
                        this.showPorducts()
                        this.showTitle()
                        awdScroll.update()
                        awdScroll.start()
                    })
                })
            })
        })
    }

    setCurrentCategory(categoriaCliccata){
        this.categorieAjax.forEach(categoria => {
            categoria.classList.remove('current')
        })
        categoriaCliccata.classList.add('current')
    }

    hideTitle(){
        gsap.to(this.pageShopTitle, {
            duration: 0.5,
            autoAlpha: 0,
            onComplete: () => {
                this.pageShopTitle.innerHTML = this.categoryName
            }
        })
    }
    showTitle(){
        gsap.to(this.pageShopTitle, {
            duration: 1,
            autoAlpha: 1
        })
    }

    hidePorducts(){
        return new Promise(resolve => {
            gsap.to(this.productsWrapper,{
                duration: 0.5,
                autoAlpha: 0,
                onComplete: () => {
                    resolve()
                }
            })
        })
    }
    showPorducts(){
        gsap.to(this.productsWrapper,{
            duration: 0.8,
            autoAlpha: 1,
        })
    }

    reinitSVGRoundedButtons(){
        this.products = [...this.productsWrapper.querySelectorAll('.product')]
        this.products.forEach( product => {
            // const button = product.querySelector('.svg-')
            new SVGRoundedButtons(product)
        })

    }

    scrollToTop(){
        let scrollY = parseInt(document.querySelector('body').getAttribute('data-scroll-y'))
        this.duration = ((scrollY+50)/(winsize.height)) * 1000
        // let duration = ((scrollY+50)/(winsize.height)) * 1000
        let options = {
            // offset: this.offset,
            duration: this.duration,
            easing: [0.62, 0.02, 0.38, 0.98],
            callback: () => {
                this.isScrolling = false
            }
        }
        if(!isAllMobileDevices){
            awdScroll.scrollTo(0,options)
        }
        else{
            jQuery('html, body').animate({
                scrollTop:0,
              },
              {
                easing: 'linear',
                duration: this.duration,
                complete: function(){

               }
           });

        }
    }

    ajaxFilter(categoryId) {
        return new Promise(resolve => {
            let formData = new FormData(this.form)
            let request = new XMLHttpRequest()
            let url = document.getElementById('uri').value + '/AJAX/filters.php'
            formData.append('categoryId', categoryId)
            request.open('POST', url, true)
            request.onreadystatechange = () => {
                if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                    setTimeout(() => {
                        this.productsWrapper.innerHTML = request.response
                        resolve()
                    }, this.duration)
                }
            }
            request.send(formData)
        })
    }    
}

export {AjaxFilters}